const headingcontent = [
    {id:0,
        title1:"Olá, seja bem vindo",
       title2:"Eu sou Ramon Fávero",
       title3:"Morador do Rio de Janeiro, Estudante de programação Fullstack com um apreço muito grande por ciência de dados.",
    button:"Projetos"
    },
    {id:1,
        title1:"Hello and Welcome",
       title2:"I'm Ramon Fávero",
       title3:"Full Stack developer student with focus on data science based in Rio de Janeiro - Brazil.",
       button:"Projects"
    },
]
export default headingcontent